import { ImageWidget } from "~/types/widgets";
import Image from "~/components/ui/Image";

interface Props {
  title?: string;
  paymentIcons?: PaymentIcon[];
}

export interface PaymentIcon {
  name: string;
  image: ImageWidget;
  width?: number;
  height?: number;
}

function PaymentMethods({ title, paymentIcons }: Props) {
  return (
    <div className="flex flex-col items-center xl:flex-row">
      {title && (
        <h3 className="font-['Poppins'] not-italic font-bold leading-[14px] tracking-[0.06em] uppercase text-sm text-[#333333] mb-2.5 xl:mb-0">
          {title}
        </h3>
      )}
      {paymentIcons && paymentIcons.length
        ? (
          <ul className="flex flex-row flex-wrap items-center justify-center gap-2.5 xl:ml-[30px]">
            {paymentIcons.map(({ name, width, height, image }) => {
              return (
                <li title={name}>
                  <Image
                    loading="lazy"
                    fetchPriority="low"
                    width={width ?? 40}
                    height={height ?? 15}
                    src={image}
                    alt={name}
                  />
                </li>
              );
            })}
          </ul>
        )
        : <></>}
    </div>
  );
}

export default PaymentMethods;
